import { useQuery } from "@tanstack/react-query";
import {
  ApiError,
  ApiServiceError,
  GetListRequestParams,
  GetListResponse
} from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { InventoryInsightsListItem } from "../../insights.types";
import { requestInventoryInsights } from "./inventoryInsights.request";

const useInventoryInsights = (
  requestParams: GetListRequestParams,
  options?: QueryOptions<
    GetListResponse<InventoryInsightsListItem>,
    ApiServiceError<ApiError>
  >
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["products", "with-low-quantity", requestParams],
    queryFn: async () => await requestInventoryInsights(requestParams),
    ...options
  });

  return { inventoryInsightsProducts: data?.data, meta: data?.meta, ...rest };
};

export default useInventoryInsights;
